import React from 'react';
import {Box, Button} from '@mui/material';
import withAutoFormNew, {AutoFormProps} from '../../components/AutoForm/AutoFormNew';
import AutoField, {
  ActionType,
  AutoTextField,
} from '../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';

export type UpdateEmailFormValues = {
  currentEmail: string;
  newEmail: string;
  confirmEmail: string;
};

const UpdateEmailFormInner: React.FC<AutoFormProps<UpdateEmailFormValues>> = () => {
  const {submitForm} = useAutoForm<UpdateEmailFormValues>();
  const currentEmailField: AutoTextField<UpdateEmailFormValues> = {
    id: 'currentEmail',
    label: 'Current Email',
    type: ActionType.text,
    readOnly: true,
    size: 'small',
  };

  const newEmailField: AutoTextField<UpdateEmailFormValues> = {
    id: 'newEmail',
    label: 'New Email',
    type: ActionType.text,
    email: true,
    size: 'small',
  };

  const confirmEmailField: AutoTextField<UpdateEmailFormValues> = {
    id: 'confirmEmail',
    label: 'Confirm New Email',
    type: ActionType.text,
    email: true,
    size: 'small',
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} pt={2}>
      <AutoField field={currentEmailField} />
      <AutoField field={newEmailField} />
      <AutoField field={confirmEmailField} />
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={submitForm}>
          Update
        </Button>
      </Box>
    </Box>
  );
};

export const UpdateEmailForm = withAutoFormNew<UpdateEmailFormValues, unknown>(
  UpdateEmailFormInner,
  undefined,
  {debugPosition: 'bottom'}
);
